import React from 'react';
import styles from "./Trialbutton.module.scss";

const Trialbutton = () => {
  return (
    <div className={styles.Button}>
        15-days free trial
    </div>
  )
}

export default Trialbutton;

{/* <button onClick={() => navigate(`/payment?plan=${cardname}&price=${currPrice}`)}></button> */}

{/* <button onClick={() => loadRazorpay(currPrice, description)}></button> */}